import { Link } from 'react-router';
import { Badge, StateBadge } from '../../../ui/Badge';
import { Card } from '../../../ui/misc';
import { Timestamp } from '../../../ui/Timestamp';
import type { ReleaseDetail } from '../types';

export function Attempts({ r, base }: { r: ReleaseDetail; base: string }) {
  return (
    <Card title="Attempts">
      {r.attempts.length === 0 ? (
        <span className="small muted">No attempts yet.</span>
      ) : (
        <ul className="checklist">
          {r.attempts.map((a) => (
            <li key={a.id} style={{ justifyContent: 'space-between' }}>
              <Link to={`${base}/attempts/ATT-${a.number}`} className="mono">
                ATT-{a.number}
              </Link>
              <span className="row nowrap">
                <StateBadge state={a.state} />
                {a.provenance && <StateBadge state={a.provenance} />}
                {a.awaitingVerification && <Badge tone="info">Manual checks</Badge>}
                {a.needsReport && <Badge tone="warning">Run not linked</Badge>}
                {a.dispatchError && (
                  <Badge tone="warning" title={a.dispatchError}>
                    Dispatch problem
                  </Badge>
                )}
                <span className="small muted">
                  {a.executor ? `${a.executor.name} · ` : ''}
                  <Timestamp value={a.registeredAt} />
                </span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
